import React, { useEffect, useState } from "react";
import { Col, Row, Form, Container, Card, Button, Breadcrumb, Navbar, } from "react-bootstrap";
import { connect } from "react-redux";
import { getData } from "./Report.action";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import IconMenu from "../../../drawer/IconMenu";


const ReportView = (props) => {
  const [item, setItem] = useState("");
  const getItem = props.List.map((x) => {
    let data = { value: x._id, label: x.reportName };
    return data;
  });
  const handleChangeLedgerItem = (selectedOption) => {
    setItem(selectedOption.value);
  };

  useEffect(() => {
    props.getData();
  }, []);

  return (
    <>
      <div >
        <Navbar style={{ backgroundColor: '#81abd3' }}  >
          <Container>
            <Navbar.Brand style={{ color: 'white' }}><b>Reports</b></Navbar.Brand>
            <IconMenu />
          </Container>
        </Navbar>
      </div>
      {props.isFetchingData ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="border"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid style={{ backgroundColor: "#f6f7fb" }}>
          <div className="main" style={{ backgroundColor: "#f6f7fb" }}>

            <Row>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to="/home"> Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Report</Breadcrumb.Item>
              </Breadcrumb>
            </Row>

            <div>
              <Form>
                <Row>
                  <Col lg="4" md="4" sm="4"></Col>
                  <Col lg="4" md="4" sm="4"></Col>
                  <Col lg="4" md="4" sm="4">
                    <Form.Group>
                      <Select
                        placeholder="Select Item"
                        onChange={handleChangeLedgerItem}
                        options={getItem}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Accordion>
                  {/* sale */}
                  <Card style={{ marginTop: 10 }}>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: 8 }}> Sales Reports </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col>
                            <Form.Label>
                              <Link to="/daliy/sale-report">Daily Sale Report</Link>
                            </Form.Label>
                          </Col>
                          <Col>
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>

                          <Col>
                            <Form.Label>
                              <Link to="/monthly/sale-report"> Monthly Sale Report </Link>
                            </Form.Label>
                          </Col>
                          <Col>
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="5" md="5" sm="5">
                            <Form.Label>
                              <Link to="/Report/Product-Sale-report">
                                Product Sale Report
                              </Link>
                            </Form.Label>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>

                          <Col lg="5" md="5" sm="5">
                            <Form.Label>
                              <Link to="/Report/Specific-Product-Sale-report">
                                Specific Product Sale Report
                              </Link>
                            </Form.Label>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="5" md="5" sm="5">
                            <Form.Label>
                              <Link to="/Report/hot-selling-report">
                                Hot Selling Report
                              </Link>
                            </Form.Label>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                          <Col lg="5" md="5" sm="5">
                            <Form.Label>
                              <Link to="/daliy/dayOpen-sale-report">
                                Daily Sale Report (without Day Open)
                              </Link>
                            </Form.Label>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                  {/* Orders */}
                  <Card style={{ marginTop: "5px" }}>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header style={{ padding: 8 }}>
                        Orders Report
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* <Row>
            <Col lg="5" md="5" sm="5">
            <Link to="/daliy/order-billed-report">
            Daily Order Billed Report
                </Link>
            </Col>
            <Col lg="1" md="1" sm="1">
              <StarBorderIcon style={{color:"#0D6EFD"}}/>
            </Col>
            <Col lg="5" md="5" sm="5">
            <Link to="/monthly/order-billed-report">
            Monthly Order Billed Report
                </Link>
            </Col>
            <Col lg="1" md="1" sm="1">
              <StarBorderIcon style={{color:"#0D6EFD"}}/>
            </Col>
          </Row> */}
                        <Row>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/daliy/orderCancel-report">
                              Daily Order Cancellation Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/monthly/orderCancel-report">
                              Monthly Order Cancellation Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                  {/* Discount */}
                  <Card style={{ marginTop: "5px" }}>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header style={{ padding: 8 }}>
                        Discount Report
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/daliy/discount-report">
                              Daily Discount Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/monthly/discount-report">
                              Monthly Discount Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                  {/* promo */}
                  <Card style={{ marginTop: "5px" }}>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header style={{ padding: 8 }}>
                        Promo Report
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/daliy/promo-report">
                              Daily Promo Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                          <Col lg="5" md="5" sm="5">
                            <Link to="/monthly/promo-report">
                              Monthly Promo Report
                            </Link>
                          </Col>
                          <Col lg="1" md="1" sm="1">
                            <StarBorderIcon style={{ color: "#0D6EFD" }} />
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                  {/* <Card style={{marginTop:"5px"}}>
      <Accordion.Item eventKey="3">
        <Accordion.Header style={{padding:8}}>Invoices Report</Accordion.Header>
        <Accordion.Body>
        <Row>
        <Col lg="5" md="5" sm="5">
        <Link to="/daliy/invoice-report">
        Daily Invoices Report
                </Link>
            </Col>
            <Col lg="1" md="1" sm="1">
              <StarBorderIcon style={{color:"#0D6EFD"}}/>
            </Col>
            <Col lg="5" md="5" sm="5">
            <Link to="/monthly/invoice-report">
            Monthly Invoices Report
                </Link>
              
            </Col>
            <Col lg="1" md="1" sm="1">
              <StarBorderIcon style={{color:"#0D6EFD"}}/>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
      </Card> */}
                </Accordion>
                {/* <Row>

                  <Col lg="12" sm="12" className="text-center" style={{marginTop: '30px'}}>
                    <Link to="/inventory/material-ledger-details">
                      <Button className="sendButton" onClick={(e) => searchData(e.target.value)} >Search</Button>
                    </Link>
                  </Col>
                </Row> */}
              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: () => dispatch(getData()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  List: state.ReportReducer.Data,
  isFetchingData: state.ReportReducer.isFetchingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportView);
